
import { useState } from "react";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/lib/supabase";
import { CalendarSettings } from "@/lib/supabase";
import { calendarSettingsToDb } from "./calendar-settings-mapper";

export const useCalendarSave = () => {
  const [isSaving, setIsSaving] = useState(false);
  const { toast } = useToast();

  const saveCalendarSettings = async (
    settings: CalendarSettings, 
    user: any | null,
    isClientView: boolean
  ) => {
    if (isClientView) {
      toast({
        title: "Accesso limitato",
        description: "Non hai i permessi per modificare le impostazioni del calendario",
        variant: "destructive"
      });
      return false;
    }
    
    if (!settings.startHour || !settings.endHour || !settings.workDays?.length) {
      toast({
        title: "Errore di validazione",
        description: "Compila tutti i campi richiesti",
        variant: "destructive",
      });
      return false;
    }

    if (!user) {
      toast({
        title: "Errore di autenticazione",
        description: "Devi essere autenticato per salvare le impostazioni",
        variant: "destructive",
      });
      return false;
    }

    try {
      setIsSaving(true);
      
      const updatedSettings = {
        ...settings,
        user_id: user.id
      };
      
      const dbSettings = calendarSettingsToDb(updatedSettings);
      
      console.log("Salvando impostazioni con user_id:", dbSettings.user_id);
      console.log("Fasce orarie non disponibili:", dbSettings.unavailable_slots);
      
      if (settings.id) {
        const { error } = await supabase
          .from('calendar_settings')
          .update({
            start_hour: dbSettings.start_hour,
            end_hour: dbSettings.end_hour,
            work_days: dbSettings.work_days,
            unavailable_slots: dbSettings.unavailable_slots,
            user_id: dbSettings.user_id
          })
          .eq('id', settings.id);
          
        if (error) throw error;
      } else {
        const { error } = await supabase
          .from('calendar_settings')
          .insert({
            start_hour: dbSettings.start_hour,
            end_hour: dbSettings.end_hour,
            work_days: dbSettings.work_days,
            unavailable_slots: dbSettings.unavailable_slots,
            user_id: dbSettings.user_id
          });
          
        if (error) throw error;
      }
      
      toast({
        title: "Impostazioni salvate",
        description: "Le impostazioni del calendario sono state aggiornate",
      });
      
      return true;
    } catch (error) {
      console.error(error);
      toast({
        title: "Errore",
        description: "Impossibile salvare le impostazioni",
        variant: "destructive",
      });
      return false;
    } finally {
      setIsSaving(false);
    }
  };

  return {
    isSaving,
    saveCalendarSettings
  };
};
